__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "mycrm-portal";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("./src/mfe/exposed", "0", () => (Promise.all([__webpack_require__.e(4662), __webpack_require__.e(4299), __webpack_require__.e(1524), __webpack_require__.e(5031), __webpack_require__.e(5977), __webpack_require__.e(2582), __webpack_require__.e(2089), __webpack_require__.e(7629), __webpack_require__.e(2950), __webpack_require__.e(4712), __webpack_require__.e(9715), __webpack_require__.e(9240), __webpack_require__.e(3819), __webpack_require__.e(308), __webpack_require__.e(2956), __webpack_require__.e(8387), __webpack_require__.e(7103), __webpack_require__.e(5221), __webpack_require__.e(2819)]).then(() => (() => (__webpack_require__(18387))))));
			register("@okta/okta-auth-js", "6.5.1", () => (Promise.all([__webpack_require__.e(4578), __webpack_require__.e(6652), __webpack_require__.e(2594)]).then(() => (() => (__webpack_require__(46652))))));
			register("@okta/okta-auth-js", "6.6.2", () => (Promise.all([__webpack_require__.e(4578), __webpack_require__.e(347), __webpack_require__.e(3074)]).then(() => (() => (__webpack_require__(40347))))));
			register("axios", "0.24.0", () => (__webpack_require__.e(9669).then(() => (() => (__webpack_require__(9669))))));
			register("history", "4.10.1", () => (__webpack_require__.e(71).then(() => (() => (__webpack_require__(90071))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(3935), __webpack_require__.e(2950), __webpack_require__.e(7418)]).then(() => (() => (__webpack_require__(73935))))));
			register("react-router-dom", "5.2.0", () => (Promise.all([__webpack_require__.e(5977), __webpack_require__.e(2950), __webpack_require__.e(9715), __webpack_require__.e(3727)]).then(() => (() => (__webpack_require__(73727))))));
			register("react", "17.0.2", () => (__webpack_require__.e(7294).then(() => (() => (__webpack_require__(67294))))));
			register("rox-browser", "4.9.18", () => (__webpack_require__.e(18).then(() => (() => (__webpack_require__(50018))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};